import { render, staticRenderFns } from "./department-info.vue?vue&type=template&id=17f42b8f&"
import script from "./department-info.vue?vue&type=script&lang=js&"
export * from "./department-info.vue?vue&type=script&lang=js&"
import style0 from "./department-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports